import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import { GET_BOOKING_FAILED, GET_BOOKING_REQUESTED, GET_BOOKING_SUCCESS } from "resources/actionTypes";
import { bookingApi } from "services/ReportService";

function* fetchBooking(action) {
  try {
    const payload = action.payload || {}
    const userBooking = yield call(bookingApi, payload);
    yield put({ type: GET_BOOKING_SUCCESS, userBooking: userBooking });
  } catch (e) {
    yield put({ type: GET_BOOKING_FAILED, message: e.message })
    toast.error(e.message || 'Get Booking Failed')
  }
}

export function* bookingSaga() {
  yield takeEvery(GET_BOOKING_REQUESTED, fetchBooking);
}